import { GoogleLogin } from '@react-oauth/google';
import { useEffect } from 'react';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router-dom';
import api from '../service/api';
import useUserStore from '../store/user';

export default function HomePage() {
  const user = useUserStore(state => state.user);
  const setUser = useUserStore(state => state.setUser);
  const isInitialized = useUserStore(state => state.isInitialized);
  const checkSession = useUserStore(state => state.checkSession);
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    if (!isInitialized) {
      checkSession();
    }
  }, [isInitialized, checkSession]);

  const login = async (googleJWTToken?: string) => {
    if (!googleJWTToken) {
      console.error('Did not receive Google JWT token');
      return;
    }

    try {
      await api.sessionCreate(googleJWTToken);
      setUser(await api.userCurrentGet());
    } catch (error) {
      console.error(error);
      api.sessionDestroy();
    }
  };

  // Check if there's an invitation code in the location state
  const invitationCode = location.state?.invitationCode;

  // Show loading while checking session
  if (!isInitialized) {
    return (
      <Container>
        <Row className="min-vh-100 align-items-center justify-content-center">
          <Col xs={12} className="text-center">
            <Spinner animation="border" />
          </Col>
        </Row>
      </Container>
    );
  }

  // Only redirect if we came here directly (not from another route)
  if (user && !location.state?.from) {
    // If user just logged in with an invitation code, redirect to invitation page
    if (invitationCode) {
      return <Navigate to={`/invitation/${invitationCode}`} replace />;
    }

    // Otherwise, normal redirect based on role
    return (
      <Navigate to={user.isManager ? '/manager/home' : '/profile'} replace />
    );
  }

  return (
    <Container>
      <Row className="min-vh-100 align-items-center justify-content-center">
        <Col xs={12} md={6} lg={4} className="text-center">
          <p className="mb-4 fs-4">
            {invitationCode
              ? t('auth.pleaseLoginToAcceptInvitation')
              : t('auth.pleaseLogin')}
          </p>
          <div className="d-flex justify-content-center">
            <GoogleLogin
              onSuccess={credentialResponse => {
                login(credentialResponse?.credential);
              }}
              onError={(...args) => {
                console.log('Login Failed', args);
              }}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
